import PullQuote from "@/components/PullQuote";
import Seo from "@/components/Seo";
import { PAGE_META } from "@/lib/seo";
import { useBooking } from "@/context/BookingContext";
import { QUOTES } from "@/data/site";

export default function About() {
  const { openBooking } = useBooking();
  return (
    <div data-testid="about-page">
      <Seo {...PAGE_META.about} />
      <section className="relative py-24 bg-gradient-to-br from-[#280000] to-[#0A0A0A]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <p className="text-rgv-red font-display uppercase tracking-[0.3em] mb-4">Our Story</p>
          <h1 className="font-display font-extrabold italic uppercase fluid-h1">
            About <span className="text-rgv-red">RGV Gaming</span>
          </h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-16">
        <p className="text-rgv-gray text-lg leading-relaxed">
          RGV Gaming brings a mobile gaming experience like no other, right to your home or
          business. Play individually or as a team across a huge range of multiplayer games on the
          newest hardware — PlayStation 5 Slim, Xbox Series X, Nintendo Switch OLED, and Oculus
          Quest 3. We run 10 Intel NUC i7 gaming systems with Pixio curved monitors for a truly
          immersive setup, plus 2 dedicated &ldquo;gaming gurus&rdquo; on-site to run the show and
          make sure everyone has the best possible experience.
        </p>

        <PullQuote quotes={QUOTES.about} />

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
          {[
            ["10", "Gaming PCs"],
            ["4", "Consoles"],
            ["1", "Oculus VR"],
            ["2", "Gaming Gurus"],
          ].map(([n, l]) => (
            <div key={l} className="hover-glow border border-rgv-maroon rounded-xl bg-[#111] p-6 text-center">
              <div className="font-display text-4xl text-rgv-red">{n}</div>
              <div className="text-rgv-gray uppercase text-sm mt-1 font-display">{l}</div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button onClick={() => openBooking()} data-testid="about-book-btn" className="btn-skew btn-red px-8 py-4 text-lg">
            <span>Bring RGV Gaming To You</span>
          </button>
        </div>
      </section>
    </div>
  );
}
